import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const routeNames: Record<string, string> = {
  admin: "Dashboard",
  cadastros: "Cadastros",
  profissionais: "Profissionais",
  pacientes: "Pacientes",
  configuracoes: "Configurações",
  emails: "E-mails",
  templates: "Templates",
  "tabelas-preco": "Tabelas de Preço",
};

export function AdminBreadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Don't show breadcrumbs on root /admin route
  if (pathnames.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground">
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const label = routeNames[value] || value;

        return (
          <div key={to} className="flex items-center">
            {index > 0 && <ChevronRight className="h-4 w-4 mx-1" />}
            {isLast ? (
              <span className="text-foreground font-medium">{label}</span>
            ) : (
              <Link to={to} className="hover:text-foreground transition-colors">
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
